import { BsBook } from "react-icons/bs";
import { MdOutlineCollectionsBookmark } from "react-icons/md";
import { MdOutlinePayment } from "react-icons/md";
import { FaHandHoldingUsd } from "react-icons/fa";

export const categories = [
  {
    id: 1,
    title: "Photography",
    image: "cate_1.png",
  },
  {
    id: 2,
    title: "Trading Cards",
    image: "cate_2.png",
  },
  {
    id: 3,
    title: "Utility",
    image: "cate_3.png",
  },
  {
    id: 4,
    title: "Vitual World",
    image: "cate_4.png",
  },
  {
    id: 5,
    title: "Music",
    image: "cate_5.png",
  },
  {
    id: 6,
    title: "Others",
    image: "cate_3.png",
    icon: true,
  },
];

export const authors = [
  {
    id: 1,
    cover: "autors_1.png",
    profileImg: "user_1.png",
    profileName: "Myrwyn Braybrook",
    address: "1Hnvw6LKkYhwL1Hf9b82dzi2ByLre8757Z",
    title: "Support",
    image: "discover_1.png",
    timeline: "10:3:2021",
    category: "Cartoon",
    price: "3.61",
    status: true,
    currency: "ETH",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 2,
    cover: "autors_2.png",
    profileImg: "user_2.png",
    profileName: "Bev Keiling",
    address: "1Hnvw6LKkYhwL1Hf9b82dzi2ByLre8757Z",
    title: "Marketing",
    image: "discover_2.png",
    timeline: "8:26:2021",
    category: "Art",
    price: "1.87",
    status: true,
    currency: "bit",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 3,
    cover: "autors_3.png",
    profileImg: "user_3.png",
    profileName: "Jodi Claypool",
    address: "1Hnvw6LKkYh757ZesrtBHE547",
    title: "Marketing",
    image: "discover_3.png",
    timeline: "2:6:2022",
    category: "Art",
    price: "1.86",
    status: false,
    currency: "Solana",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 4,
    cover: "autors_4.png",
    profileImg: "user_4.png",
    profileName: "Cayla Goodinge",
    address: "1Hnvw6LKkYhwL1Hf9b82dzi2ByLre8757Z",
    title: "Sales",
    image: "discover_4.png",
    timeline: "3:5:2022",
    category: "Image",
    price: "2.83",
    status: false,
    currency: "Polygon",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 5,
    cover: "autors_5.png",
    profileImg: "user_5.png",
    profileName: "Justine Sweetzer",
    address: "KkYhwL1Hf9b82dzi2ByLre8757Zwy",
    title: "Research and Development",
    image: "discover_5.png",
    timeline: "11:8:2021",
    category: "Cartoon",
    price: "9.40",
    status: true,
    currency: "bit",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 6,
    cover: "autors_6.png",
    profileImg: "user_6.png",
    profileName: "Harmon Rozalski",
    address: "kYhwL1Hf9b82dzi2ByLre8757ZDd547d",
    title: "Marketing",
    image: "discover_6.png",
    timeline: "4:15:2022",
    category: "Image",
    price: "1.68",
    status: false,
    currency: "ETH",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 7,
    cover: "autors_7.png",
    profileImg: "user_7.png",
    profileName: "Margarita Santo",
    address: "BUJvw6LKkYhwL1Hf2dzi2ByLre8sdrt5",
    title: "Marketing",
    image: "discover_7.png",
    timeline: "11:30:2021",
    category: "Cartoon",
    price: "4.63",
    status: true,
    currency: "Solana",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 8,
    cover: "autors_8.png",
    profileImg: "user_8.png",
    profileName: "Willie Prescot",
    address: "998Hnvw6LKkYhwL1Hf9b82dzi2ByLre",
    title: "Sales",
    image: "discover_8.png",
    timeline: "11:29:2021",
    category: "Art",
    price: "0.13",
    status: false,
    currency: "bit",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 9,
    cover: "autors_9.png",
    profileImg: "user_9.png",
    profileName: "Quinton Fairburn",
    address: "w6LKkYhwL1Hf9b82dzi2ByLre8757Zseh",
    title: "Human Resources",
    image: "discover_9.png",
    timeline: "4:2:2022",
    category: "Image",
    price: "1.85",
    status: true,
    currency: "Polygon",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 10,
    cover: "autors_10.png",
    profileImg: "user_10.png",
    profileName: "Godfry Lesper",
    address: "1Hnvw6LKkdftgert6547yLre8757Z",
    title: "Training",
    image: "discover_10.png",
    timeline: "2:4:2022",
    category: "Art",
    price: "4.95",
    status: true,
    currency: "ETH",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 11,
    cover: "autors_4.png",
    profileImg: "user_4.png",
    profileName: "Willabella Iddy",
    address: "6LKkYhwL1Hf9b82dzi2ByLre8757ZsdfwGEGV",
    title: "Product Management",
    image: "discover_11.png",
    timeline: "3:27:2022",
    category: "Cartoon",
    price: "5.08",
    status: false,
    currency: "Solana",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
  {
    id: 12,
    cover: "autors_7.png",
    profileImg: "user_7.png",
    profileName: "Koressa Freeman",
    address: "1Hnvw6LKkYhwL1Hf9b82dzi2ByLre8757Z",
    title: "Research",
    image: "discover_12.png",
    timeline: "4:6:2022",
    category: "Art",
    price: "8.42",
    status: true,
    currency: "bit",
    userId: "@thesalvare",
    description:
      "Integer non velit. Donec diam neque, vestibulum eget, vulputate ut, ultrices vel, augue. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec pharetra, magna vestibulum aliquet ultrices, erat tortor sollicitudin mi, sit amet lobortis sapien sapien non mi. Integer ac neque. Duis bibendum. Morbi non quam nec dui luctus rutrum.",
    creation: "60",
    follower: "100k",
    following: "85k",
  },
];

export const productDetails = [
  {
    id: 1,
    title: "LiverFellaz #2451",
    image: "discover_1.png",
    timeline: "10:3:2021",
    details: "Aopanda is a popular panda character on TikTok created by a Japanese animator.Big panda is Ah chan,Mini panda is Oh chan They are opanda!We mainly send out animations that make you feel importance of words and animations that make you have positive thinking!",
    bid: "Highest bid",
    price: "3.61",
    owners: 3,
  },
  {
    id: 2,
    title: "LiverFellaz #2452",
    image: "discover_2.png",
    timeline: "8:26:2021",
    details: "Weird Eth Keeper' is part of the Ethereum themed collection of 10 portraits under the main collection of Weird Narrative.Weird Narrative is a collection of weird portraits centered around narratives and themes. 1/1 art by Nabila Ibrahim.",
    bid: "Way",
    price: "1.87",
    owners: 3,
  },
  {
    id: 3,
    title: "LiverFellaz #2453",
    image: "discover_3.png",
    timeline: "2:6:2022",
    details: "A collection of 10,000 undead NFTs minted on the Etheream blockchain. Each unique deadfella is randomly generated from a combination of over 400 individually",
    bid: "Circle",
    price: "1.86",
    owners: 3,
  },
  {
    id: 4,
    title: "LiverFellaz #2455",
    image: "discover_20.png",
    timeline: "3:5:2022",
    details: "Arcus: a dense, horizontal, roll-shaped cloud sometimes occurring at the lower front portion of a cumulonimbus. This is a collection of 1/1's crafted by Dutch artist Rik Oostenbroek over the course of the past 5 years",
    bid: "Lane",
    price: "2.83",
    owners: 3,
  },
  {
    id: 5,
    title: "LiverFellaz #2458",
    image: "discover_5.png",
    timeline: "11:8:2021",
    details: "Aopanda is a popular panda character on TikTok created by a Japanese animator.Big panda is Ah chan,Mini panda is Oh chan They are opanda!We mainly send out animations that make you feel importance of words and animations that make you have positive thinking!",
    bid: "Crossing",
    price: "9.40",
    owners: 3,
  },
  {
    id: 6,
    title: "LiverFellaz #2469",
    image: "discover_6.png",
    timeline: "4:15:2022",
    details: "Weird Eth Keeper' is part of the Ethereum themed collection of 10 portraits under the main collection of Weird Narrative.Weird Narrative is a collection of weird portraits centered around narratives and themes. 1/1 art by Nabila Ibrahim.",
    bid: "Way",
    price: "1.87",
    owners: 3,
  },
  {
    id: 7,
    title: "LiverFellaz #2473",
    image: "discover_7.png",
    timeline: "11:30:2021",
    details: "Arcus: a dense, horizontal, roll-shaped cloud sometimes occurring at the lower front portion of a cumulonimbus. This is a collection of 1/1's crafted by Dutch artist Rik Oostenbroek over the course of the past 5 years",
    bid: "Park",
    price: "0.13",
    owners: 3,
  },
  {
    id: 8,
    title: "LiverFellaz #1653",
    image: "discover_8.png",
    timeline: "11:29:2021",
    details: "Aopanda is a popular panda character on TikTok created by a Japanese animator.Big panda is Ah chan,Mini panda is Oh chan They are opanda!We mainly send out animations that make you feel importance of words and animations that make you have positive thinking!",
    bid: "Park",
    price: "0.13",
    owners: 3,
  },
  {
    id: 9,
    title: "LiverFellaz #1053",
    image: "discover_9.png",
    details: "Weird Eth Keeper' is part of the Ethereum themed collection of 10 portraits under the main collection of Weird Narrative.Weird Narrative is a collection of weird portraits centered around narratives and themes. 1/1 art by Nabila Ibrahim.",
    bid: "Way",
    price: "1.87",
    owners: 3,
  },
  {
    id: 10,
    title: "LiverFellaz #9466",
    image: "discover_10.png",
    timeline: "2:4:2022",
    details: "Aopanda is a popular panda character on TikTok created by a Japanese animator.Big panda is Ah chan,Mini panda is Oh chan They are opanda!We mainly send out animations that make you feel importance of words and animations that make you have positive thinking!",
    bid: "Park",
    price: "0.13",
    owners: 3,
  },
  {
    id: 11,
    title: "LiverFellaz #8590",
    image: "discover_11.png",
    timeline: "3:27:2022",
    details: "Arcus: a dense, horizontal, roll-shaped cloud sometimes occurring at the lower front portion of a cumulonimbus. This is a collection of 1/1's crafted by Dutch artist Rik Oostenbroek over the course of the past 5 years",
    bid: "Park",
    price: "0.13",
    owners: 3,
  },
  {
    id: 12,
    title: "LiverFellaz #0027",
    image: "discover_12.png",
    timeline: "4:6:2022",
    details: "Weird Eth Keeper' is part of the Ethereum themed collection of 10 portraits under the main collection of Weird Narrative.Weird Narrative is a collection of weird portraits centered around narratives and themes. 1/1 art by Nabila Ibrahim.",
    bid: "Way",
    price: "1.87",
    owners: 3,
  },
];

export const artists = [
  {
    id: 1,
    image: "art_1.png",
    artistsName: "Cecilius MacNaughton",
    price: "$1.80",
    artistsUser: "user_1.png",
    status: true,
  },
  {
    id: 2,
    image: "art_2.png",
    artistsName: "Sarajane Boichat",
    price: "$5.81",
    artistsUser: "user_2.png",
    status: false,
  },
  {
    id: 3,
    image: "art_3.png",
    artistsName: "Liza Leatham",
    price: "$3.04",
    artistsUser: "user_3.png",
    status: true,
  },
  {
    id: 4,
    image: "art_4.png",
    artistsName: "Tobey Lodden",
    price: "$5.48",
    artistsUser: "user_4.png",
    status: true,
  },
  {
    id: 5,
    image: "art_5.png",
    artistsName: "Moses Lutman",
    price: "$4.23",
    artistsUser: "user_5.png",
    status: false,
  },
  {
    id: 6,
    image: "art_6.png",
    artistsName: "Liza Leatham",
    price: "$8.13",
    artistsUser: "user_6.png",
    status: true,
  },
  {
    id: 7,
    image: "art_7.png",
    artistsName: "Warde Faughnan",
    price: "$7.16",
    artistsUser: "user_7.png",
    status: false,
  },
  {
    id: 8,
    image: "art_8.png",
    artistsName: "Tobey Lodden",
    price: "$9.50",
    artistsUser: "user_8.png",
    status: true,
  },
];

export const collection = [
  {
    id: 1,
    collImgOne: "coll_1.png",
    collImgTwo: "coll_2.png",
    collImgThree: "coll_3.png",
    collUser: "user_1.png",
    collTitle: "Kristin Watson",
    collValue: "294",
    collReview: "4",
    status: true,
  },
  {
    id: 2,
    collImgOne: "coll_4.png",
    collImgTwo: "coll_5.png",
    collImgThree: "coll_6.png",
    collUser: "user_2.png",
    collTitle: "Kristin Romero",
    collValue: "100",
    collReview: "5",
    status: false,
  },
  {
    id: 3,
    collImgOne: "coll_7.png",
    collImgTwo: "coll_8.png",
    collImgThree: "coll_9.png",
    collUser: "user_3.png",
    collTitle: "Lionel Messi",
    collValue: "133",
    collReview: "5",
    status: true,
  },
  {
    id: 4,
    collImgOne: "coll_10.png",
    collImgTwo: "coll_11.png",
    collImgThree: "coll_12.png",
    collUser: "user_4.png",
    collTitle: "Rodrigo de paul",
    collValue: "60",
    collReview: "5",
    status: false,
  },
  {
    id: 5,
    collImgOne: "coll_13.png",
    collImgTwo: "coll_14.png",
    collImgThree: "coll_15.png",
    collUser: "user_5.png",
    collTitle: "Lautaro Martínez",
    collValue: "80",
    collReview: "3",
    status: true,
  },
  {
    id: 6,
    collImgOne: "coll_16.png",
    collImgTwo: "coll_10.png",
    collImgThree: "coll_5.png",
    collUser: "user_6.png",
    collTitle: "John Arthur Butler",
    collValue: "294",
    collReview: "4",
    status: true,
  },
  {
    id: 7,
    collImgOne: "coll_8.png",
    collImgTwo: "coll_9.png",
    collImgThree: "coll_11.png",
    collUser: "user_7.png",
    collTitle: "Emma Watson",
    collValue: "90",
    collReview: "3",
    status: false,
  },
  {
    id: 8,
    collImgOne: "coll_5.png",
    collImgTwo: "coll_15.png",
    collImgThree: "coll_10.png",
    collUser: "user_8.png",
    collTitle: "Christian Eriksen",
    collValue: "309",
    collReview: "5",
    status: true,
  },
  {
    id: 9,
    collImgOne: "coll_4.png",
    collImgTwo: "coll_5.png",
    collImgThree: "coll_6.png",
    collUser: "user_2.png",
    collTitle: "Kristin Watson",
    collValue: "100",
    collReview: "5",
    status: false,
  },
  {
    id: 10,
    collImgOne: "coll_7.png",
    collImgTwo: "coll_8.png",
    collImgThree: "coll_9.png",
    collUser: "user_3.png",
    collTitle: "Kristin Watson",
    collValue: "133",
    collReview: "5",
    status: true,
  },
  {
    id: 11,
    collImgOne: "coll_10.png",
    collImgTwo: "coll_11.png",
    collImgThree: "coll_12.png",
    collUser: "user_4.png",
    collTitle: "Kristin Watson",
    collValue: "60",
    collReview: "5",
    status: false,
  },
  {
    id: 12,
    collImgOne: "coll_13.png",
    collImgTwo: "coll_14.png",
    collImgThree: "coll_15.png",
    collUser: "user_5.png",
    collTitle: "Kristin Watson",
    collValue: "80",
    collReview: "3",
    status: true,
  },
];

export const blog = [
  {
    id: 1,
    blogThamble: "blog_1.png",
    blogTitle: "Universidad Mariana",
    blogPostUserName: "James",
    blogPostUser: "user_1.png",
    date: "23-Mar-2022",
    blogContent: "What the hell is NFT? How does it work?",
    minRead: "3 min.to read",
    detailsBlog: [
      {
        id: 1,
        date: '24 NOV',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '19 NOV',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
  {
    id: 2,
    blogThamble: "blog_2.png",
    blogTitle: "Feati University",
    blogPostUserName: "John",
    blogPostUser: "user_2.png",
    date: "10-Sep-2021",
    blogContent: "How to Develop White Label NFT Marketplace",
    minRead: "3 min. to read",
    detailsBlog: [
      {
        id: 1,
        date: '24 NOV',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '19 NOV',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
  {
    id: 3,
    blogThamble: "blog_3.png",
    blogTitle: "University of Perpetual Help",
    blogPostUserName: "Michael",
    blogPostUser: "user_3.png",
    date: "22-Nov-2021",
    blogContent: "Difference between NFT and Cryptocurrency",
    minRead: "3 min. to read",
    detailsBlog: [
      {
        id: 1,
        date: '12 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '9 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
  {
    id: 4,
    blogThamble: "blog_4.png",
    blogTitle: "Henderson State Univerisity",
    blogPostUserName: "David",
    blogPostUser: "user_4.png",
    date: "09-Dec-2021",
    blogContent: "Difference between NFT and Cryptocurrency",
    minRead: "3 min. to read",
    detailsBlog: [
      {
        id: 1,
        date: '12 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '9 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
  {
    id: 5,
    blogThamble: "blog_5.png",
    blogTitle: "Perlis Islamic Higher Learning Institute",
    blogPostUserName: "Elizabeth",
    blogPostUser: "user_5.png",
    date: "14-May-2022",
    blogContent: "error: undefined method `id' for nil:NilClass",
    minRead: "3 min. to read",
    detailsBlog: [
      {
        id: 1,
        date: '12 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '9 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
  {
    id: 6,
    blogThamble: "blog_6.png",
    blogTitle: "Musashi University",
    blogPostUserName: "Margaret",
    blogPostUser: "user_5.png",
    date: "12-Nov-2021",
    blogContent: "Difference between NFT and Cryptocurrency",
    minRead: "3 min. to read",
    detailsBlog: [
      {
        id: 1,
        date: '12 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '9 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
  {
    id: 7,
    blogThamble: "blog_3.png",
    blogTitle: "FAAP - Fundação Armando Alvares Penteado",
    blogPostUserName: "Timothy",
    blogPostUser: "user_7.png",
    date: "20-Jan-2022",
    blogContent: "Create an Amazing Store With us",
    minRead: "3 min. to read",
    detailsBlog: [
      {
        id: 1,
        date: '12 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '9 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
  {
    id: 8,
    blogThamble: "blog_4.png",
    blogTitle: "American University of Tirana",
    blogPostUserName: "Kenneth",
    blogPostUser: "user_8.png",
    date: "19-Dec-2021",
    blogContent: "What the hell is NFT? How does it work?",
    minRead: "3 min. to read",
    detailsBlog: [
      {
        id: 1,
        date: '12 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '9 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
  {
    id: 9,
    blogThamble: "blog_2.png",
    blogTitle: "Mahidol University",
    blogPostUserName: "George",
    blogPostUser: "user_9.png",
    date: "16-May-2022",
    blogContent: "Create an Amazing Store With us",
    minRead: "3 min. to read",
    detailsBlog: [
      {
        id: 1,
        date: '12 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '9 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
  {
    id: 10,
    blogThamble: "blog_3.png",
    blogTitle: "Point Park College",
    blogPostUserName: "Benjamin",
    blogPostUser: "user_10.png",
    date: "28-Mar-2022",
    blogContent: "What the hell is NFT? How does it work?",
    minRead: "3 min. to read",
    detailsBlog: [
      {
        id: 1,
        date: '12 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_2.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
      {
        id: 2,
        date: '9 September',
        title: 'Create an Amazing Store With us',
        options: 'In Fashion, Clothing | No Comments | Hen Whitman',
        img: 'blog_d_1.png',
        blogText: 'The love boat soon will be making another run. The love boat promises something for everyone. Just two Good old boys Wouldn’t change if they could. Fighthin’ the system like a true model day Robin Hood. That this Group would somehow form a family that’s the way we all become the Brady Bunch...'
      },
    ]
  },
];

export const allSelect = [
  {
    selectName: "Blockchains",
    selectOptions: [
      {
        optionName: "All",
        optionValue: "",
      },
      {
        optionName: "Etherum",
        optionValue: "ETH",
      },
      {
        optionName: "Bitcoin",
        optionValue: "bit",
      },
      {
        optionName: "BNB",
        optionValue: "bnb",
      },
      {
        optionName: "Polygon",
        optionValue: "Polygon",
      },
      {
        optionName: "Solana",
        optionValue: "Solana",
      },
    ]
  },
  {
    selectName: "Category",
    selectOptions: [
      {
        optionName: "All",
        optionValue: "",
      },
      {
        optionName: "Art",
        optionValue: "Art",
      },
      {
        optionName: "Cartoon",
        optionValue: "Cartoon",
      },
      {
        optionName: "Image",
        optionValue: "Image",
      },
      {
        optionName: "Art",
        optionValue: "Art",
      },
      {
        optionName: "Cartoon",
        optionValue: "Cartoon",
      },
    ]
  },
  {
    selectName: "On Sale",
    selectOptions: [
      {
        optionName: "1 Day ago",
        optionValue: 1,
      },
      {
        optionName: "2 Days ago",
        optionValue: 2,
      },
      {
        optionName: "3 Days ago",
        optionValue: 3,
      },
      {
        optionName: "4 Days ago",
        optionValue: 4,
      },
      {
        optionName: "5 Days ago",
        optionValue: 5,
      },
      {
        optionName: "6 Days ago",
        optionValue: 6,
      },
      {
        optionName: "1 Week ago",
        optionValue: 7,
      },
    ]
  },
  {
    selectName: "Price Range",
    selectOptions: [
      {
        optionName: "Default",
        optionValue: "",
      },
      {
        optionName: "High to low",
        optionValue: "htl",
      },
      {
        optionName: "Low to High",
        optionValue: "lth",
      },
    ]
  },
]

export const headerLinks = [
  {
    headerName: "Explore",
    route: "explore"
  },
  {
    headerName: "Ranking",
    route: "ranking"
  },
  {
    headerName: "Popular",
    route: "popular"
  },
  {
    headerName: "Blog",
    route: "ourblog"
  },
  {
    headerName: "Pages",
    route: "",
    dropdown: [
      {
        pageName: "Product Details",
        route: "product/1"
      },
      {
        pageName: "Author list",
        route: "authors"
      },
      {
        pageName: "Blog Details",
        route: "blogdetails/1"
      },
      {
        pageName: "Upload Work",
        route: "uploadwork"
      },
      {
        pageName: "Profile",
        route: "profile/1"
      },
      {
        pageName: "Contact",
        route: "contact"
      },
      {
        pageName: "Wallet",
        route: "connectwallet"
      },
      {
        pageName: "FAQ",
        route: "faq"
      },
      {
        pageName: "Privacy & Policy",
        route: "privacy"
      },
      {
        pageName: "Error",
        route: "error"
      },
    ]
  },
]

export const ranking = [
  {
    rankingImg: "rank-1.png",
    UserName: "Art Blocks Factory",
    price: "223.45",
    priceUsd: "$282,891",
    floorPrice: "0.04",
    floorPriceUsd: "$438",
  },
  {
    rankingImg: "rank-2.png",
    UserName: "Sandbox's LANDs",
    price: "223.45",
    priceUsd: "$282,891",
    floorPrice: "0.04",
    floorPriceUsd: "$438",
  },
  {
    rankingImg: "rank-3.png",
    UserName: "MutantApeYachtClub",
    price: "223.45",
    priceUsd: "$282,891",
    floorPrice: "0.04",
    floorPriceUsd: "$438",
  },
  {
    rankingImg: "rank-4.png",
    UserName: "Gutter Cat Gang",
    price: "223.45",
    priceUsd: "$282,891",
    floorPrice: "0.04",
    floorPriceUsd: "$438",
  },
  {
    rankingImg: "rank-5.png",
    UserName: "VeeFriends Series",
    price: "223.45",
    priceUsd: "$282,891",
    floorPrice: "0.04",
    floorPriceUsd: "$438",
  },
  {
    rankingImg: "rank-6.png",
    UserName: "VeeFriends Series",
    price: "223.45",
    priceUsd: "$282,891",
    floorPrice: "0.04",
    floorPriceUsd: "$438",
  },
  {
    rankingImg: "rank-7.png",
    UserName: "NFT Worlds",
    price: "223.45",
    priceUsd: "$282,891",
    floorPrice: "0.04",
    floorPriceUsd: "$438",
  },

]

export const tabData = {
  tabHeader: [
    {
      id: 1,
      icon: <BsBook />,
      heading: "Getting Started"
    },
    {
      id: 5,
      icon: <MdOutlineCollectionsBookmark />,
      heading: "Collecting"
    },
    {
      id: 9,
      icon: <MdOutlinePayment />,
      heading: "Payment"
    },
    {
      id: 13,
      icon: <FaHandHoldingUsd />,
      heading: "Selling"
    },
  ],
  tabs: [
    {
      tab: [
        {
          id: 1,
          uid: 1,
          question: "How to apply for a Master Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 2,
          uid: 2,
          question: "How to apply for a Master Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 3,
          uid: 3,
          question: "How to apply for a Master Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 4,
          uid: 4,
          question: "How to apply for a Master Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
      ],
    },
    {
      tab: [
        {
          id: 1,
          uid: 5,
          question: "How to apply for a Visa Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 2,
          uid: 6,
          question: "How to apply for a Visa Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 3,
          uid: 7,
          question: "How to apply for a Visa Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 4,
          uid: 8,
          question: "How to apply for a Visa Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
      ],
    },
    {
      tab: [
        {
          id: 1,
          uid: 9,
          question: "How to apply for a Paypal Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 2,
          uid: 10,
          question: "How to apply for a Paypal Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 3,
          uid: 11,
          question: "How to apply for a Paypal Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 4,
          uid: 12,
          question: "How to apply for a Paypal Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
      ],
    },
    {
      tab: [
        {
          id: 1,
          uid: 13,
          question: "How to apply for a Prepaid Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 2,
          uid: 14,
          question: "How to apply for a Prepaid Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 3,
          uid: 15,
          question: "How to apply for a Prepaid Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
        {
          id: 4,
          uid: 16,
          question: "How to apply for a Prepaid Card?",
          answer1: "Far far away, behind the word mountains, far from the countries Vocalic and Consonantal, there live the blind texts. Separated they live in Bookmarks grove right at the coast of the Semantics, a large language ocean. A small river named Durden flows by their place and supplies it with the necessary regelialia.It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
          answer2: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
        },
      ],
    }
  ]
}